export default __webpack_public_path__ + "static/media/ic-minimum-attendance.fe2cf5d1.svg";